<template>
	<div class="my-talent main-content-padding">
		<div class="yx-background-white radius-8 pl-24 pr-24 pt-12">
			<platformTab @change="platformTabClick" :showAll="false" :platformId="platformId" />
			<Abnormal-toast
				@showReAllotDialog="showReAllotDialog"
				:showNotice="showNotice"
				:showStatus="showStatus"
				:anchorCount="anchorCount"
				:taskStatus="taskStatus"
				:platformId="platformId"
				v-show="showPlatformContent"
			></Abnormal-toast>
		</div>

		<div style="position: relative" class="yx-background-white" v-show="showPlatformContent">
			<SubTabs @tab-click="getListData" :list="tabs" :value="+activeTab" class="ml-24">
				<template slot-scope="{ item }">
					<div>
						<span>{{ item.tab_name }}</span>
						<span class="ml-4">{{ item.tab_count }}</span>
					</div>
				</template>
			</SubTabs>
			<tab
				:key="platformId"
				:platform-id="platformId"
				:partner_list="partner_list"
				ref="tabRefs"
				:cooperate-status="+activeTab + 1"
				:focus="focus"
				:liveSaleList="liveSaleList"
				:monthLiveSaleList="monthLiveSaleList"
				@showRelationDialog="showRelationDialog"
				@showAddTalentDialog="showAddTalentDialog"
				@showdetailDrawer="showdetailDrawer"
				@showImportDialog="showImportDialog"
				@getTalentManageTab="getTalentManageTab"
				:fansNum="fansNum"
			/>
			<div class="fr yx-color-solid-1 fz-14 pointer retop" @click="showCooperDialog">
				<i class="el-icon-notebook-2 exprot-icon"></i>
				<span>合作状态说明</span>
			</div>
		</div>
		<build-contact-dialog ref="buildContactDialog" @getList="getList" />
		<add-talent-dialog :platform-id="platformId" ref="addTalentDialog" @refresh="getList" />
		<detail-drawer ref="detailDrawer" @getList="getList" :activeTab="'3'" />
		<import-dialog :platform-id="platformId" ref="importDialog" :sourcePage="sourcePage" @getList="getList" />
		<setting ref="setting" @getList="getList" />
		<ReAllot-dialog ref="reAllotDialog" :platformId="platformId" @changeStatus="changeStatus" @getTaskStatus="getTaskStatus"></ReAllot-dialog>
		<el-dialog title="合作状态说明" :visible.sync="dialogVisible" width="466px">
			<p v-for="item in CooperText" :key="item.index" style="margin-left: 0px; color: black">
				{{ item.text }}
			</p>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" type="primary">我知道了</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import tab from './components/tab';
import AbnormalToast from '../components/abnormalToast';
import buildContactDialog from '../components/buildContactDialog';
import addTalentDialog from '@/views/common/dialog/addTalent.vue';
import importDialog from './components/importDialog';
import ReAllotDialog from '@/views/talentCRM/components/reAllotDialog';
import detailDrawer from '../components/detailDrawer';
import setting from './components/setting';
import { platformMixin } from '@rd/rd-ui';
import { getTalentManageTab, partnerList, getPartnerAnchor, clueSelectList } from '@/api/talentCRM';
import { mapGetters } from 'vuex';
import { drRoleType } from '@/utils/dataMap';
import talentCRMMixin from '../components/mixins';
import SubTabs from '@/components/ui/subTabs/index.vue';
export default {
	name: 'myTalent',
	props: {
		focus: {
			type: Number,
			default: 1,
		},
		sourcePage: {
			type: String,
			default: 'myTalent',
		},
	},
	components: {
		tab,
		buildContactDialog,
		addTalentDialog,
		detailDrawer,
		importDialog,
		setting,
		ReAllotDialog,
		AbnormalToast,
		SubTabs,
	},
	provide() {
		return {
			showDetailDrawer: row => this.showdetailDrawer(row.anchor_id),
			getTalentManageTab: this.getTalentManageTab,
			getTalentList: this.getTalentList,
		};
	},
	mixins: [platformMixin, talentCRMMixin],
	computed: {
		...mapGetters(['defaultPlatform']),
	},
	async created() {
		const { tabid } = this.$route.query;
		this.activeTab = tabid || '0';
		this.partnerList();
		this.clueSelectList();
		this.getTalentStatus();
		await this.getTalentManageTab();
		this.getTalentList();
	},
	data() {
		return {
			activeTab: '0',
			tabs: [],
			partner_list: [],
			platformId: '',
			dialogVisible: false,
			talentNum: 0,
			anchorCount: 0,
			showNotice: false,
			taskStatus: 0,
			wait_fix: 0,
			showStatus: 0,
			timer: null,
			CooperText: [
				{
					text: '线索：未建联达人即包括未添加微信或打电话沟通取得联系的达人',
					index: 0,
				},
				{
					text: '已建联：已成功添加微信的达人',
					index: 1,
				},
				{
					text: '已申样：已申请样品但未开播出订单的达人',
					index: 2,
				},
				{
					text: '已成交：已有合作带货的达人',
					index: 3,
				},
			],
			liveSaleList: [],
			monthLiveSaleList: [],
			fansNum: [],
		};
	},
	destroyed() {
		clearInterval(this.timer);
		this.timer = null;
		this.showNotice = false;
		this.showStatus = 0;
	},
	methods: {
		async getTalentManageTab() {
			const { focus, platformId: platform_id } = this;
			const { code, data } = await getTalentManageTab({ focus, platform_id });
			if (code !== 0) return;
			this.tabs = data.map(function (obj) {
				return { ...obj, name: obj.tab_id - 1 };
			});
		},
		async partnerList() {
			const { code, data } = await partnerList({ role_id: drRoleType.id, all_status: 1, dataView: 1 });
			if (code !== 0) return;
			this.partner_list = data;
			// 将数组分成三个部分
			const notUseStatus2AndNotDeleted = this.partner_list.filter(item => item.use_status !== '2' && !item.deleted);
			const useStatus2 = this.partner_list.filter(item => item.use_status === '2' && !item.deleted);
			// 账号已删除的不显示
			// const deleted = this.partner_list.filter(item => item.deleted);
			// 合并三个部分
			this.partner_list = [...notUseStatus2AndNotDeleted, ...useStatus2];
		},
		getListData(name) {
			this.activeTab = String(name);
			this.$nextTick(() => {
				this.$refs.tabRefs.onClear();
				this.getTalentManageTab();
			});
		},
		getList() {
			this.getTalentManageTab();
			this.getTalentList();
		},
		getTalentList() {
			this.$nextTick(() => {
				this.$refs.tabRefs.getList();
			});
		},
		showRelationDialog(row) {
			this.$refs.buildContactDialog.show(row);
		},
		showAddTalentDialog(anchor_id) {
			this.$refs.addTalentDialog.show(anchor_id);
		},
		showdetailDrawer(anchor_id) {
			this.$refs.detailDrawer.show(anchor_id);
		},
		showImportDialog() {
			this.$refs.importDialog.show();
		},
		showReAllotDialog() {
			this.$refs.reAllotDialog.show(this.platformId);
		},
		settingFun() {
			const { platform_id } = this;
			this.$refs.setting.show(platform_id);
		},
		platformTabClick(val) {
			this.$nextTick(() => {
				this.$refs.tabRefs.onClear();
				this.getTalentManageTab();
			});
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.clueSelectList();
			this.getTalentStatus();
			this.activeTab = '0';
		},
		showCooperDialog() {
			this.dialogVisible = true;
		},
		changeStatus(val) {
			this.showStatus = val;
		},
		async getTalentStatus() {
			const {
				code,
				data: { wait_fix, task_status, wait_fix_num, many_partner },
			} = await getPartnerAnchor({ platform_id: this.platformId });
			if (code !== 0) return;
			this.taskStatus = task_status;
			this.anchorCount = wait_fix_num;
			this.wait_fix = wait_fix;
			if (!many_partner && wait_fix_num > 0) {
				//不允许1对多的情况且存在多条数据时，会显示改提示
				this.showNotice = true;
				this.showStatus = 1;
			} else {
				this.showNotice = false;
				this.showStatus = 0;
			}
		},
		//轮询来观测任务状态
		getTaskStatus() {
			this.timer = setInterval(async () => {
				const { task_status } = await getPartnerAnchor({ platform_id: this.platformId });
				if (task_status) {
					this.showStatus = 2;
				} else {
					this.showStatus = 3;
					clearInterval(this.timer);
				}
			}, 1000);
		},
		async clueSelectList() {
			const { code, data } = await clueSelectList({ platformId: this.platformId });
			if (code != 0) return;
			this.liveSaleList = data.liveSale || [];
			this.monthLiveSaleList = data.fee30 || [];
			this.fansNum = data.fansNum;
		},
	},
};
</script>

<style lang="less" scoped>
.rule {
	position: absolute;
	top: 15px;
	right: 20px;
	cursor: pointer;
}

.rule:hover {
	color: @color-primary;
}

.tipsBox {
	padding: 8px 10px;
	margin-bottom: 10px;
	border-radius: 2px;

	img {
		width: 16px;
		height: 16px;
	}
}

.warning {
	background: #fef3e7;
	border: 1px solid #fba543;
}

.el-dialog p {
	margin-top: 10px;
	margin-left: 55px;
}

.retop {
	position: absolute;
	right: 24px;
	top: 5px;
	z-index: 99;
}

.exprot-icon {
	position: relative;
	font-size: 14px;
}
.myTalent_subTab {
	::v-deep .el-tabs__header {
		padding-left: 24px;
		padding-right: 24px;
	}
}
</style>
